import { endpoint } from 'services/endpoint';
import { httpPay } from 'services/http';
import { TPaymentMethodsApi } from './types';

export const paymentMethods: TPaymentMethodsApi = {
	getPaymentMethods: () =>
		httpPay.get(endpoint.paymentMethods.LIST).then((response) => response.data),
	getSummary: (options) =>
		httpPay
			.get(
				endpoint.paymentMethods.SUMMARY,
				options?.background ? { skipAuthRedirect: true } : undefined,
			)
			.then((response) => response.data),
	getServices: () =>
		httpPay.get(endpoint.paymentMethods.SERVICES).then((response) => response.data),
	updateMethodServices: ({ id, allServices, serviceIds }) =>
		httpPay
			.put(endpoint.paymentMethods.METHOD_SERVICES(id), { allServices, serviceIds })
			.then((response) => response.data),
	setDefault: (id) =>
		httpPay.post(endpoint.paymentMethods.DEFAULT(id)).then((response) => response.data),
	deleteMethod: (id) =>
		httpPay.delete(endpoint.paymentMethods.DELETE(id)).then((response) => response.data ?? {}),
	startSetup: (payload) =>
		httpPay.post(endpoint.paymentMethods.SETUP, payload).then((response) => response.data),
	getSetup: (setupId) =>
		httpPay.get(endpoint.paymentMethods.SETUP_GET(setupId)).then((response) => response.data),
	completeSetup: ({ setupId, intentId, consentId }) =>
		httpPay
			.post(endpoint.paymentMethods.SETUP_COMPLETE(setupId), {
				intentId: intentId ?? null,
				consentId: consentId ?? null,
			})
			.then((response) => response.data),
	getBanks: () => httpPay.get(endpoint.directDebit.BANKS).then((response) => response.data),
	createDirectDebit: (payload) =>
		httpPay.post(endpoint.directDebit.CREATE, payload).then((response) => response.data),
	verifyDirectDebit: (payload) =>
		httpPay.post(endpoint.directDebit.VERIFY, payload).then((response) => response.data),
	// background: the restrictions are optional for the page, a 401 here does not sign the user out
	getClientAccess: () =>
		httpPay
			.get(endpoint.paymentMethods.CLIENT_ACCESS, { skipAuthRedirect: true })
			.then((response) => response.data),
};
